import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Mail, ArrowLeft, Send, Loader2, AlertCircle, CheckCircle } from 'lucide-react';
import styles from './ForgotPassword.module.css';
import { authAPI } from '../../api/authApi';
import logo from './logo.jpg';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ message: '', type: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ message: '', type: '' });

    try {
      await authAPI.request_password_reset({ email });
      setStatus({
        message: 'Se o e-mail existir, enviaremos as instruções em instantes.',
        type: 'success'
      });
    } catch (err) {
      console.error(err);
      setStatus({
        message: 'Erro ao enviar o pedido. Tente novamente mais tarde.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.container}>
      {/* Efeitos de fundo */}
      <div className={styles.blobBlue} />
      <div className={styles.blobGold} />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.card}
      >
        {/* Destaque para a Logo */}
        <div className={styles.logoWrapper}>
          <img src={logo} alt="Logo" className={styles.logoImage} />
        </div>

        <header className={styles.header}>
          <h2 className={styles.title}>Recuperar senha</h2>
          <p className={styles.subtitle}>
            Informe seu e-mail para receber o link de redefinição.
          </p>
        </header>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <div className={styles.inputWrapper}>
              <Mail className={styles.icon} size={18} />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com"
                className={styles.input}
                required
              />
            </div>
          </div>

          <motion.button
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.99 }}
            type="submit"
            className={styles.button}
            disabled={loading}
          >
            {loading ? (
              <Loader2 className={styles.spinner} size={20} />
            ) : (
              <>
                <span>Enviar Link</span>
                <Send size={16} />
              </>
            )}
          </motion.button>
        </form>

        <AnimatePresence mode="wait">
          {status.message && (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, height: 0 }}
              className={`${styles.status} ${status.type === 'success' ? styles.success : styles.error}`}
            >
              {status.type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
              <span>{status.message}</span>
            </motion.div>
          )}
        </AnimatePresence>

        <footer className={styles.footer}>
          <Link to="/login" className={styles.backLink}>
            <ArrowLeft size={16} /> Voltar para o login
          </Link>
        </footer>
      </motion.div>
    </div>
  );
}